export default __webpack_public_path__ + "static/media/cross.bf3fbe60.png";